import React, { useState } from 'react';
import { Stack, Typography, Button } from '@mui/material';
import PhotoCapture from '../components/PhotoCapture';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import api from '../Services/Api';
import * as Sentry from "@sentry/browser";
import Loading from '../components/Loading';
import { useOutletContext } from 'react-router-dom';
import Recorder from '../components/Recorder';

function PhotoScreen({ isBusinessCard = false }) {
  const { t } = useTranslation();
  const { setHide } = useOutletContext();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [ocrText, setOcrText] = useState(null);
  const [showRecorder, setShowRecorder] = useState(false);
  const [imageSrc, setImageSrc] = useState(null);
  const navigate = useNavigate();

  const handleCapture = async (imageSrc) => {
    setLoading(true);
    setHide(true);
    if (isBusinessCard) {
      handleBusinessCard(imageSrc);
    } else {
      handlePhoto(imageSrc);
    }
  };

  const handleBusinessCard = async (imageSrc) => {
    try {
      const response = await api.uploadPhoto(imageSrc);
      setOcrText(response.text);
      setShowRecorder(true);
    } catch (error) {
      Sentry.captureException(error);
      setError(true);
      setErrorMessage(t('errorProcessingPhoto'));
      setHide(false);
    } finally {
      setLoading(false);
    }
  };

  const handlePhoto = async (imageSrc) => {
    setImageSrc(imageSrc);
    setShowRecorder(true);
    setLoading(false);
  };

  const handleAudioRecorded = async (audio) => {
    setLoading(true);
    setHide(true);
    try {
      // Send audio to API
      if (isBusinessCard) {
        const response = await api.UploadAudio(audio);
        navigate("/app/validate", { state: { text: response.text, ocrText: ocrText } });
      } else {
        const response = await api.UploadAudio(audio);
        let ocrText = await api.uploadPhoto(imageSrc, response.text);

        navigate("/app/validate", { state: { text: ocrText.text } });
      }
    } catch (error) {
      Sentry.captureException(error);
      setError(true);
      setErrorMessage(t('errorSendingAudio'));
      setHide(false);
    } finally {
      setLoading(false);
    }
    
  };



  return (
    <Stack direction="column" justifyContent="center" alignItems="center" style={{height: "100vh", width: "100%"}}>
      <Loading loading={loading} />
      
      {error && (
        <Typography 
          style={{
            backgroundColor: "white", 
            color: "red", 
            position: "absolute", 
            width: "90%", 
            left: "5%", 
            right: "5%",
            top: "5%", 
            padding: "16px",
            borderRadius: "8px",
            textAlign: "center"
          }}
        >
          {errorMessage}
        </Typography>
      )}

      <Stack direction="column" justifyContent="center" alignItems="center">
        {!showRecorder ? (
          <PhotoCapture onCapture={handleCapture} />
        ) : (
          <Stack spacing={2} alignItems="center">
            <Recorder 
              small={true} 
              finished={handleAudioRecorded}
              onClear={() => setHide(false)}
              onStopRecording={() => setHide(false)}
              example={ocrText}
              onStart={() => {
                setError(false);
                setHide(true);
              }}
            />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}

export default PhotoScreen; 